module.exports = __webpack_public_path__ + "static/media/qb.a07fc290.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/qb.png
// module id = 1838
// module chunks = 146